import { Navigate, useParams } from 'react-router-dom';
import { useAssetMeta } from '../lib/assets';

/**
 * What a shelf label's QR code opens: /assets/place/<id> goes to the
 * stocktake page for that place - or, for a desk (108), to the desk's
 * page, since a desk's label is printed from the same place-label page.
 */
export default function AssetPlace() {
  const { id } = useParams();
  const meta = useAssetMeta();
  if (!meta) return null;
  const desk = (meta.locations || []).some((l) => l.id === id && l.kind === 'desk');
  return <Navigate to={desk ? `/assets/desks/${id}` : `/assets/stocktake/${id}`} replace />;
}
